import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {List} from 'shells/dashboard/list/list';
// @ts-expect-error - imported from .js/.jsx file
import {SortDownIcon} from 'shells/icon/svg/sort-down-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';

import type {
    GetEditionsDashboard_editionsDashboard_scheduledEditions as ScheduledEdition,
    GetEditionsDashboard_editionsDashboard_draftEditions as DraftEdition,
} from 'nutshell-graphql-types';

type Props = {
    scheduledEditions: ScheduledEdition[];
    draftEditions: DraftEdition[];
};

export function EditionsList(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <List
                title='Scheduled'
                rightText={
                    <div className='flex align-center gap-4'>
                        <SortDownIcon size={14} color={colors.greyLt} alignCenter={true} />
                        Next in queue
                    </div>
                }
                borderColor={colors.orange}
                listItems={props.scheduledEditions.map(mapEditionToListItem)}
                emptyStateText='Scheduled emails will appear here in queue order'
            />
            <List
                title='Drafts'
                rightText={
                    <div className='flex align-center gap-4'>
                        <SortDownIcon size={14} color={colors.greyLt} alignCenter={true} />
                        Last updated
                    </div>
                }
                borderColor={colors.blue}
                listItems={props.draftEditions.map(mapEditionToListItem)}
                emptyStateText='Drafted emails will appear here by latest update'
            />
        </StackLegacy>
    );
}

const mapEditionToListItem = (edition: any) => ({
    id: edition.id,
    name: edition.name,
    htmlUrlPath: edition.htmlUrlPath,
    subtitle: <RelativeTimestamp datetime={edition.scheduledTime || edition.modifiedTime} />,
});
